import React from 'react';
import { useState } from 'react';
import { Fab, Zoom, Popover, Box } from '@material-ui/core';
import ViewListIcon from '@material-ui/icons/ViewList';
import Tooltip from '@material-ui/core/Tooltip';

const QUESTIONS_PER_PAGE = 10;

const QuestionNavigator = ({ questions, onQuestionClick, showScrollUp }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const totalPages = Math.ceil(questions.length / QUESTIONS_PER_PAGE);
    const startIndex = (currentPage - 1) * QUESTIONS_PER_PAGE;
    const currentQuestions = questions.slice(startIndex, startIndex + QUESTIONS_PER_PAGE);

    const goToNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const scrollToQuestion = (questionId) => {
        const element = document.getElementById(`question-${questionId}`);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
                if (onQuestionClick && typeof onQuestionClick === 'function') {
                    onQuestionClick(questionId);
                }
            }, 600);
        }
    };

    return (
        <>
            {/* Кнопка навигатора с CSS-анимацией */}
            <div className={`question-navigator-button ${showScrollUp ? 'scrolled-up' : ''}`}>
                <Tooltip title="Вопросы" placement="left">
                    <Fab
                        color="primary"
                        size="small"
                        aria-label="questions"
                        onClick={handleClick}
                        style={{
                            backgroundColor: '#ccc',
                        }}
                    >
                        <ViewListIcon style={{ color: 'black' }} />
                    </Fab>
                </Tooltip>
            </div>

            {/* Меню с кнопками */}
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                disableScrollLock
                PaperProps={{
                    style: {
                        boxShadow: 'none',
                        backgroundColor: 'transparent',
                    },
                }}
            >
                <Box
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        padding: '8px',
                        backgroundColor: 'transparent',
                        maxHeight: 'none',
                        overflowY: 'visible',
                    }}
                >
                    {currentQuestions.map((q, index) => {
                        const questionNumber = startIndex + index + 1;
                        return (
                            <div key={q.question_id} className="question-button">
                                <Fab
                                    size="small"
                                    style={{
                                        width: 40,
                                        height: 40,
                                        fontSize: '14px',
                                        backgroundColor: 'white',
                                        color: 'black',
                                        border: '1px solid #ccc',
                                        margin: '0 auto',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                        handleClose();
                                        scrollToQuestion(q.question_id);
                                    }}
                                >
                                    {questionNumber}
                                </Fab>
                            </div>
                        );
                    })}
                    <div style={{ alignSelf: 'center' }}>
                        {totalPages > 1 && currentPage > 1 && (
                            <div className="question-button">
                                <Fab
                                    size="small"
                                    style={{
                                        width: 40,
                                        height: 40,
                                        fontSize: '14px',
                                        backgroundColor: '#e0e0e0',
                                        color: 'black',
                                        border: '1px solid #ccc',
                                        cursor: 'pointer',
                                        marginBottom: '8px'
                                    }}
                                    onClick={goToPrevPage}
                                >
                                    ←
                                </Fab>
                            </div>
                        )}
                        {totalPages > 1 && currentPage < totalPages && (
                            <div className="question-button">
                                <Fab
                                    size="small"
                                    style={{
                                        width: 40,
                                        height: 40,
                                        fontSize: '14px',
                                        backgroundColor: '#e0e0e0',
                                        color: 'black',
                                        border: '1px solid #ccc',
                                        cursor: 'pointer',
                                    }}
                                    onClick={goToNextPage}
                                >
                                    →
                                </Fab>
                            </div>
                        )}
                    </div>
                </Box>
            </Popover>
        </>
    );
};

export default QuestionNavigator;